import React from 'react';
import { Z_INDEX } from '../../utils/zIndex';

interface LoadingProps {
	size?: 'small' | 'medium' | 'large';
	fullScreen?: boolean;
	text?: string;
}

const Loading: React.FC<LoadingProps> = ({
	size = 'medium',
	fullScreen = false,
	text = '加载中...',
}) => {
	const sizeClasses = {
		small: 'w-5 h-5',
		medium: 'w-8 h-8',
		large: 'w-12 h-12',
	};

	const spinner = (
		<div className="flex flex-col items-center justify-center">
			<div className={`${sizeClasses[size]} animate-spin`}>
				<svg
					className="w-full h-full"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle
						className="opacity-25"
						cx="12"
						cy="12"
						r="10"
						stroke="currentColor"
						strokeWidth="4"
					/>
					<path
						className="opacity-75"
						fill="currentColor"
						d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
					/>
				</svg>
			</div>
			{text && <p className="mt-2 text-sm text-gray-600">{text}</p>}
		</div>
	);

	if (fullScreen) {
		return (
			<div
				className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80"
				style={{ zIndex: Z_INDEX.LOADING_OVERLAY }}
			>
				{spinner}
			</div>
		);
	}

	return spinner;
};

export default Loading;
